import { createReducer, on } from "@ngrx/store";
import {
  addFlagsToTechSupportAction,
  addItemToTechSupportAction,
  clearItemsFromTechSupportAction,
  fillTechSupportAction,
  removeItemFromTechSupportAction,
  updateItemFromTechSupportAction,
} from "../actions/tech-support.actions";

export const initialtechSupportState = { items: [] };

const _techSupportReducer = createReducer(
  initialtechSupportState,

  on(fillTechSupportAction, (state, { payload }) => {
    const items = [...payload.items];

    return {
      ...state,
      items: [...items],
    };
  }),

  on(addItemToTechSupportAction, (state, { payload }) => {
    const items = [...state.items];
    items.push({ ...payload.item });

    return {
      ...state,
      items: [...items],
    };
  }),

  on(removeItemFromTechSupportAction, (state, { payload }) => {
    const items = state.items.filter((i) => i.itemNumber !== payload.item.itemNumber);

    return {
      ...state,
      items: [...items],
    };
  }),

  on(clearItemsFromTechSupportAction, (state) => {
    const items = [];
    return {
      ...state,
      items: [...items],
    };
  }),

  on(updateItemFromTechSupportAction, (state, { payload }) => {
    const items = state.items;
    const index = items.findIndex((i) => i.itemNumber === payload.itemNumber);
    if (index !== -1) {
      items[index] = {
        ...items[index],
        ...payload.item,
      };
    }

    return {
      ...state,
      items: [...items],
    };
  }),

  on(addFlagsToTechSupportAction, (state, { payload }) => {
    return {
      ...state,
      ...payload
    };
  })
);

export function techSupportReducer(state, action) {
  return _techSupportReducer(state, action);
}
